/*import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Firestore bağlantısı için firebase dosyanızdan içe aktarım yapın
import { collection, getDocs } from 'firebase/firestore'; // Firestore metodları
import './ilanlar.css'; // CSS dosyasını içe aktarın
import { useNavigate } from 'react-router-dom'; // Yönlendirme için useNavigate

const JobList = () => {
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const navigate = useNavigate(); // useNavigate hook'unu kullanarak yönlendirme

  useEffect(() => {
    const fetchJobPostings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'jobPostings'));
        const jobs = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((job) => job.mode === 'active'); // Sadece aktif ilanları filtrele
        setJobPostings(jobs);
        setLoading(false);
      } catch (error) {
        console.error('Veri alınırken hata oluştu:', error);
        setLoading(false);
      }
    };

    fetchJobPostings();
  }, []);

  const handleCloseModal = () => {
    setSelectedJob(null);
  };

  const handleApply = () => {
    navigate('/form'); // İş başvuru formuna yönlendirme
  };

  if (loading) {
    return <p className="loading">Yükleniyor...</p>;
  }

  return (
    <div className="job-list-container">
      <h2 className="title">İş İlanları</h2>
      {jobPostings.length > 0 ? (
        jobPostings.map((job) => (
          <div key={job.id} className="job-card">
            <h3 className="job-title">{job.positionName}</h3>
            <p className="job-info"><strong>Konum:</strong> {job.location}</p>
            <p className="job-info"><strong>Çalışma Şartı:</strong> {job.employmentType}</p>
            <button className="details-button" onClick={() => setSelectedJob(job)}>
              Detaylı Bilgi İçin
            </button>
          </div>
        ))
      ) : (
        <p className="no-jobs">Henüz iş ilanı eklenmemiş.</p>
      )}

      {selectedJob && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="job-title">{selectedJob.positionName}</h3>
            <p className="job-info"><strong>Konum:</strong> {selectedJob.location}</p>
            <p className="job-info"><strong>Çalışma Şartı:</strong> {selectedJob.employmentType}</p>
            <p className="job-description"><strong>İlan Metni:</strong> {selectedJob.jobDescription}</p>
            <p className="job-info"><strong>Genel Nitelikler:</strong></p>
            <ul>
              {selectedJob.qualifications.map((qualification, index) => (
                <li key={index}>{qualification}</li>
              ))}
            </ul>
            <button className="close-button" onClick={handleCloseModal}>Kapat</button>
            <button className="apply-button" onClick={handleApply}>İş Başvurusu Yap</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobList;
*/

import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Firestore bağlantısı için firebase dosyanızdan içe aktarım yapın
import { collection, getDocs } from 'firebase/firestore'; // Firestore metodları
import './ilanlar.css'; // CSS dosyasını içe aktarın
import { useNavigate } from 'react-router-dom'; // Yönlendirme için useNavigate
import { AiOutlineClose } from 'react-icons/ai';

const JobList = () => {
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const navigate = useNavigate(); // useNavigate hook'unu kullanarak yönlendirme

  useEffect(() => {
    const fetchJobPostings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'jobPostings'));
        const jobs = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((job) => job.mode === 'active'); // Sadece aktif ilanları filtrele
        setJobPostings(jobs);
        setLoading(false);
      } catch (error) {
        console.error('Veri alınırken hata oluştu:', error);
        setLoading(false);
      }
    };

    fetchJobPostings();
  }, []);

  const handleCloseModal = () => {
    setSelectedJob(null);
  };

  /*const handleApply = () => {
    navigate('/form'); // İş başvuru formuna yönlendirme
  };*/
  const handleApply = () => {
    if (selectedJob.positionName === "ReeStart Staj Programı: Teknolojiyle Buluş, Geleceğe Yön Ver!") {
      navigate('/stajbasvuru'); // Staj başvuru sayfasına yönlendirme
    } 
    else if(selectedJob.positionName === "Genel Başvuru"){
      navigate('/genelbasvuru');
    }else {
      navigate('/form'); // İş başvuru formuna yönlendirme
    }
  };

  if (loading) {
    return <p className="loading">Yükleniyor...</p>;
  }

  return (
    <div className="job-list-container">
      <h2 className="title">İş İlanları</h2>
      <div className="job-list-header">
        <span>Açık Pozisyonlar</span>
        <span>Çalışma Şartları</span>
        <span>Lokasyon</span>
      </div>
      {jobPostings.length > 0 ? (
        jobPostings.map((job) => (
          <div key={job.id} className="job-row" onClick={() => setSelectedJob(job)}>
            <span className="job-title">{job.positionName}</span>
            <span>{job.employmentType}</span>
            <span>{job.location}</span>
          </div>
        ))
      ) : (
        <p className="no-jobs">Henüz iş ilanı eklenmemiş.</p>
      )}

      {selectedJob && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <AiOutlineClose 
          className="close-icon" 
          onClick={handleCloseModal} 
        />
            <h3 className="popup-title">{selectedJob.positionName}</h3>
            <p className="popup-info"><strong className='strongs'>Konum:</strong> {selectedJob.location}</p>
            <p className="popup-info"><strong className='strongs'>Çalışma Şartı:</strong> {selectedJob.employmentType}</p>
            <p className="popup-description">{selectedJob.jobDescription}</p>
            <p className="popup-info"><strong className='strongs'>Genel Nitelikler:</strong></p>
            <ul>
              {selectedJob.qualifications.map((qualification, index) => (
                <li key={index}>{qualification}</li>
              ))}
            </ul>
            <button className="apply-button" onClick={handleApply}>Başvuru Yap</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobList;
